import React from "react";
import { Typography } from "antd";
import poerdbyLogo from "../../assets/images/vfx-powerdby.png";
const { Text, Link } = Typography;

function BottomTab({ lastFile }) {
  return (
    <div
      className={`box_wraper_div ${lastFile && "rank_footer"}`}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Text
        style={{ fontSize: "13px", fontWeight: 400, color: "#636363" }}
        type="secondary"
      >
        &#169; {new Date().getFullYear()}
        <Link
          href="https://vofox.com/"
          target="_blank"
          style={{ margin: "0 5px" }}
        >
          Vofox
        </Link>
        All Rights Reserved
      </Text>
      <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
        {lastFile && (
          <Link style={{ fontSize: "13px", fontWeight: 400 }}>
            Last File Uploaded on: {lastFile}
          </Link>
        )}
        <img
          src={poerdbyLogo}
          style={{ width: "80px" }}
          alt={`img_${poerdbyLogo}`}
        />
      </div>
    </div>
  );
}

export default BottomTab;
